<template lang="pug">
  v-container(fluid grid-list-sm v-cloak)
    v-layout(row, wrap)
      v-flex(xs12)
        v-stepper(v-model="step" vertical)
          //- ----------------------------------------
          //- 事前確認ステップ
          //- ----------------------------------------
          v-stepper-step(:complete="step > 1" step="1")
            span 留意事項確認
            small(v-if="step === 1") 事前の留意事項をご確認ください。

          v-stepper-content(step="1")
            v-layout(row, wrap)
              v-flex(xs12)
                ul
                  li 本画面は見積依頼を行う画面です。見積依頼に対し、当社担当者がメールにて見積書を回答いたします。
                  li 本画面の操作は 1 時間以内に完了してください。1時間を経過すると入力内容は自動的に破棄されます。
                v-divider.my-2
                v-btn(color="primary" outline large @click="step=2")
                  v-icon(left) arrow_downward
                  span 次へ

          //- ----------------------------------------
          //- 寸法入力ステップ
          //- ----------------------------------------
          v-stepper-step(:complete="step > 2" step="2")
            span ご依頼内容入力
            small(v-if="step === 2") ご依頼内容を入力してください。明細は３件まで追加できます。

          v-stepper-content(step="2")
            v-layout(row, wrap v-if="selection")
              v-flex(xs12 lg4 v-for="(input, index) in inputs", :key="index")
                v-card(raised)
                  v-card-title.primary.white--text
                    span No.{{index + 1}}
                    v-spacer
                    v-btn.ma-0(
                      flat
                      small
                      icon
                      color="white"
                      @click="removeInput(index)"
                      )
                      v-icon close
                  v-card-text.pa-2
                    v-layout(row, wrap)
                      //- ----------------------------------------
                      //- 寸法基準
                      //- ----------------------------------------
                      v-flex(xs12)
                        v-radio-group(
                          label="寸法基準"
                          v-model="input.method"
                          :ref="`no${index + 1}_method`"
                          :rules="[rules.required]"
                          row
                          return-object
                          )
                          v-spacer
                          v-radio(
                            v-for="method in selection.methods"
                            :key="method.id"
                            :label="method.name"
                            :value="method.id"
                            )

                        v-divider.mt-2

                      //- ----------------------------------------
                      //- 外寸基準のW/H/D
                      //- ----------------------------------------
                      v-flex(xs12 sm4 v-if="input.method === 1")
                        v-text-field(
                          type="number"
                          label="幅(W)"
                          :value="input.width"
                          @input="correlatedInput(index, 'width', $event)"
                          suffix="mm"
                          :ref="`no${index + 1}_width`"
                          :rules="[rules.required,rules.integer,rules.between(input.width, 100, 2400)]"
                          persistent-hint
                          hint="(100 - 2400)"
                          :error="!input.limitValidation || !input.widthGteDepth"
                          :error-messages="!input.limitValidation ? ['二辺以上が1400を越えることはできません。'] : !input.widthGteDepth ? ['常に幅(W)が奥行(D)以上になるように入力してください。']: []"
                          )
                      v-flex(xs12 sm4 v-if="input.method === 1")
                        v-text-field(
                          type="number"
                          label="高さ(H)"
                          :value="input.height"
                          @input="correlatedInput(index, 'height', $event)"
                          suffix="mm"
                          :ref="`no${index + 1}_height`"
                          :rules="[rules.required,rules.integer,rules.between(input.height, 100, 2400)]"
                          persistent-hint
                          hint="(100 - 2400)"
                          :error="!input.limitValidation"
                          :error-messages="!input.limitValidation ? ['二辺以上が1400を越えることはできません。'] : []"
                          )
                      v-flex(xs12 sm4 v-if="input.method === 1")
                        v-text-field(
                          type="number"
                          label="奥行(D)"
                          :value="input.depth"
                          @input="correlatedInput(index, 'depth', $event)"
                          suffix="mm"
                          :ref="`no${index + 1}_depth`"
                          :rules="[rules.required,rules.integer,rules.between(input.depth, 100, 2400)]"
                          persistent-hint
                          hint="(100 - 2400)"
                          :error="!input.limitValidation || !input.widthGteDepth"
                          :error-messages="!input.limitValidation ? ['二辺以上が1400を越えることはできません。'] : !input.widthGteDepth ? ['常に幅(W)が奥行(D)以上になるように入力してください。']: []"
                          )
                      //- ----------------------------------------
                      //- 内寸基準のW/H/D
                      //- ----------------------------------------
                      v-flex(xs12 sm4 v-if="input.method === 2")
                        v-text-field(
                          type="number"
                          label="幅(W)"
                          :value="input.width"
                          @input="correlatedInput(index, 'width', $event)"
                          suffix="mm"
                          :ref="`no${index + 1}_width`"
                          :rules="[rules.required,rules.integer,rules.between(input.width, 80, 2400)]"
                          persistent-hint
                          hint="(80 - 2400)"
                          :error="!input.limitValidation || !input.widthGteDepth"
                          :error-messages="!input.limitValidation ? ['二辺以上が1400を越えることはできません。'] : !input.widthGteDepth ? ['常に幅(W)が奥行(D)以上になるように入力してください。']: []"
                          )
                      v-flex(xs12 sm4 v-if="input.method === 2")
                        v-text-field(
                          type="number"
                          label="高さ(H)"
                          :value="input.height"
                          @input="correlatedInput(index, 'height', $event)"
                          suffix="mm"
                          :ref="`no${index + 1}_height`"
                          :rules="[rules.required,rules.integer,rules.between(input.height, 80, 2400)]"
                          persistent-hint
                          hint="(80 - 2400)"
                          :error="!input.limitValidation"
                          :error-messages="!input.limitValidation ? ['二辺以上が1400を越えることはできません。'] : []"
                          )
                      v-flex(xs12 sm4 v-if="input.method === 2")
                        v-text-field(
                          type="number"
                          label="奥行(D)"
                          :value="input.depth"
                          @input="correlatedInput(index, 'depth', $event)"
                          suffix="mm"
                          :ref="`no${index + 1}_depth`"
                          :rules="[rules.required,rules.integer,rules.between(input.depth, 80, 2400)]"
                          persistent-hint
                          hint="(80 - 2400)"
                          :error="!input.limitValidation || !input.widthGteDepth"
                          :error-messages="!input.limitValidation ? ['二辺以上が1400を越えることはできません。'] : !input.widthGteDepth ? ['常に幅(W)が奥行(D)以上になるように入力してください。']: []"
                          )
                      //- ----------------------------------------
                      //- 個数
                      //- ----------------------------------------
                      v-flex(xs12 xl4)
                        v-text-field(
                          type="number"
                          label="個数"
                          v-model="input.quantity"
                          persistent-hint
                          hint="箱の個数を入力してください。"
                          suffix="個"
                          :ref="`no${index + 1}_quantity`"
                          :rules="[rules.required,rules.integer,rules.min(input.quantity, 1),rules.max(input.quantity, 1000)]"
                          )
                      //- ----------------------------------------
                      //- オプション項目
                      //- ----------------------------------------
                      v-flex(xs12)
                        v-select(
                          :items="selection.stamps"
                          label="スタンプ"
                          v-model="input.stamps"
                          :ref="`no${index + 1}_stamps`"
                          :rules="[rules.required]"
                          multiple
                          item-text="name"
                          item-value="id"
                          return-object
                          chips
                          deletable-chips
                          small-chips
                          persistent-hint
                          hint="複数選択できます。スタンプは側面４面になります。"
                          )
                        v-divider.mt-2

                      v-flex(xs12)
                        v-checkbox(
                          v-model="input.heavy"
                          label="重量物(750kg以上)積載予定"
                          persistent-hint
                          hint="積載品は750kg以上ですか？"
                          :ref="`no${index + 1}_heavy`"
                        )
                        v-divider.mt-2

                      v-flex(xs12)
                        v-checkbox(
                          v-model="input.clog"
                          label="桁の要否"
                          persistent-hint
                          hint="桁(ケタ)は必要ですか？選択した場合は四方差しとなります。"
                          :ref="`no${index + 1}_clog`"
                        )
                        v-divider.mt-2

                      v-flex(xs12)
                        v-checkbox(
                          v-model="input.stack"
                          label="梱包後積み重ね"
                          persistent-hint
                          hint="梱包後、上に同等以上の重量物を積み重ねる予定がありますか？"
                          :ref="`no${index + 1}_stack`"
                        )
                        v-divider.mt-2

              v-flex(xs12 lg4 v-if="inputs.length === 1")
                v-card(raised)
                  v-card-title.accent.white--text
                    span No.2
                    v-spacer
                    v-btn.ma-0(
                      flat
                      small
                      icon
                      color="white"
                      @click="addInput"
                      )
                      v-icon add

              v-flex(xs12 lg4 v-if="inputs.length === 2")
                v-card(raised)
                  v-card-title.accent.white--text
                    span No.3
                    v-spacer
                    v-btn.ma-0(
                      flat
                      small
                      icon
                      color="white"
                      @click="addInput"
                      )
                      v-icon add

            v-layout(row, wrap)
              v-flex(xs12)
                v-divider.my-2
                v-btn(color="primary" outline large @click="doEstimate")
                  v-icon(left) arrow_downward
                  span 次へ
                v-btn(color="black" outline large @click="step=1")
                  v-icon(left) arrow_upward
                  span 戻る

          //- ----------------------------------------
          //- プレビューステップ
          //- ----------------------------------------
          v-stepper-step(:complete="step > 3" step="3")
            span 外形プレビュー
            small(v-if="step === 3") 3Dでの外形イメージと、外形図確認書のプレビューをご確認いただけます。

          v-stepper-content(step="3")
            v-layout(row, wrap)
              v-flex(xs12)
                v-alert(:value="true" type="info" color="accent" outline)
                  p.rem14
                    span 寸法等に誤りがないか、必ず
                    a(@click="previewDownload") こちら
                    span を開いてご確認をお願いいたします。
                p.remarks プレビューが可能な期間は１時間です。
              v-flex(xs12, sm4 v-for="(boxForThree, index) in boxesForThree", :key="index")
                v-card
                  v-card-title.primary
                    span No.{{index + 1}}
                  v-card-text.pa-1.preview-card
                    img(:src='boxForThree.image', width='100%')
                    v-btn.preview-3d(raised color='primary' icon large @click="openPreview(index)")
                      v-icon 3d_rotation
              v-dialog(v-model='previewDialog', transition='dialog-bottom-transition', :fullscreen='isMobile', :width='isMobile ? 380 : 620')
                v-toolbar.primary(dense)
                  v-spacer
                  v-btn(flat icon small @click='closePreview')
                    v-icon close
                v-card.dialog-card
                  .preview-canvas(id="preview-canvas")

            v-layout(row, wrap)
              v-flex(xs12)
                v-divider.my-2
                v-btn(color="primary" outline large @click="step=4")
                  v-icon(left) arrow_downward
                  span 次へ
                v-btn(color="black" outline large @click="step=2")
                  v-icon(left) arrow_upward
                  span 戻る

          //- ----------------------------------------
          //- 顧客情報入力ステップ
          //- ----------------------------------------
          v-stepper-step(:complete="step > 4" step="4")
            span お客様情報
            small(v-if="step === 4") お客様情報を入力してください。

          v-stepper-content(step="4")
            v-layout(row wrap v-if="step === 4")
              v-flex(xs12 sm6 md3)
                v-text-field(
                  label="御社名"
                  v-model="customer.company"
                  prepend-icon="business"
                  ref="company_name"
                  :rules="[rules.required]"
                  valitdate-on-blur
                  )
              v-flex(xs12 sm6 md3)
                v-text-field(
                  label="御担当者様"
                  v-model="customer.name"
                  prepend-icon="person"
                  ref="customer_name"
                  :rules="[rules.required]"
                  valitdate-on-blur
                  )
              v-flex(xs12 sm6 md3)
                v-text-field(
                  label="メールアドレス"
                  v-model="customer.email"
                  prepend-icon="mail"
                  ref="email"
                  :rules="[rules.required,rules.email]"
                  valitdate-on-blur
                  )
              v-flex(xs12 sm6 md3)
                v-text-field(
                  type="tel"
                  label="電話番号"
                  v-model="customer.tel"
                  prepend-icon="tel"
                  ref="tel"
                  :rules="[rules.required]"
                  valitdate-on-blur
                  )

            v-layout(row, wrap)
              v-flex(xs12)
                v-divider.my-2
                v-btn(color="primary" outline large @click="toConfirm")
                  v-icon(left) arrow_downward
                  span 次へ
                v-btn(color="black" outline large @click="step=3")
                  v-icon(left) arrow_upward
                  span 戻る

          //- ----------------------------------------
          //- 確定ステップ
          //- ----------------------------------------
          v-stepper-step(:complete="step > 5" step="5")
            span 確定
            small(v-if="step === 5") 内容を再度ご確認いただき、よろしければ「確定」を押してください。

          v-stepper-content(step="5")
            v-layout(row, wrap)
              v-flex(xs12)
                p
                  a(@click="previewDownload") こちら
                  span からプレビュー版をPDF形式で表示またはダウンロードできます。

            v-divider.my-4

            v-layout(row, wrap)
              v-flex(xs12 md4 v-for="(input, index) in inputs", :key="index")
                v-card(flat)
                  v-card-title.primary.white--text
                    span No. {{index + 1}}
                  v-card-text
                div.app-line
                  span.app-line-title 寸法基準
                  span.app-line-text {{methodString(input.method)}}
                  span.app-line-suffix &nbsp;
                div.app-line
                  span.app-line-title 幅(W)
                  span.app-line-text {{input.width}}
                  span.app-line-suffix mm
                div.app-line
                  span.app-line-title 高さ(H)
                  span.app-line-text {{input.height}}
                  span.app-line-suffix mm
                div.app-line
                  span.app-line-title 奥行(D)
                  span.app-line-text {{input.depth}}
                  span.app-line-suffix mm
                div.app-line
                  span.app-line-title 個数
                  span.app-line-text {{input.quantity}}
                  span.app-line-suffix 個
                div.app-line
                  span.app-line-title スタンプ
                  span.app-line-text {{stampsString(input.stamps)}}
                  span.app-line-suffix
                div.app-line
                  span.app-line-title 重量物指定
                  span.app-line-text {{input.heavy ? 'はい' : 'いいえ'}}
                  span.app-line-suffix
                div.app-line
                  span.app-line-title 桁要否
                  span.app-line-text {{input.clog ? '必要' : '不要'}}
                  span.app-line-suffix
                div.app-line
                  span.app-line-title 積み重ね
                  span.app-line-text {{input.stack ? 'はい' : 'いいえ'}}
                  span.app-line-suffix

            v-layout(row, wrap)
              v-flex(xs12 md6)
                v-card(flat)
                  v-card-title.primary.white--text
                    span お客様情報
                  v-card-text
                    div.app-line
                      span.app-line-title 御社名
                      span.app-line-text {{customer.company}}
                      span.app-line-suffix &nbsp;
                    div.app-line
                      span.app-line-title 御担当者名
                      span.app-line-text {{customer.name}}
                      span.app-line-suffix 様
                    div.app-line
                      span.app-line-title メールアドレス
                      span.app-line-text {{customer.email}}
                      span.app-line-suffix &nbsp;
                    div.app-line
                      span.app-line-title 電話番号
                      span.app-line-text {{customer.tel}}
                      span.app-line-suffix &nbsp;

            v-layout(row, wrap)
              v-flex(xs12)
                v-divider.my-2
                v-btn(color="success" outline large @click="doRequest")
                  v-icon(left) done
                  span 確定
                v-btn(color="black" outline large @click="step=4")
                  v-icon(left) arrow_upward
                  span 戻る

          //- ----------------------------------------
          //- 完了ステップ
          //- ----------------------------------------
          v-stepper-step(:complete="step > 6" step="6")
            span 完了
            small(v-if="step === 6") ご依頼いただきまして、ありがとうございます。

          v-stepper-content(step="6")
            v-layout(row, wrap)
              v-flex(xs12)
                v-alert(:value="true" type="success" outline)
                  span 確定した内容について、受付けさせていただきました。追って担当者より回答をご連絡させていただきます。

                v-alert(:value="true" type="success" outline)
                  span ご入力いただいたメールアドレスに確認用の内容と外形図のPDFを添付してメールさせていただきました。ご確認いただきますようお願いいたします。
                v-btn(color="black" outline large @click="step=2")
                  v-icon(left) reply
                  span もう一度見積依頼をする

        //- ----------------------------------------
        //- プレビュー計算進捗状況表示
        //- ----------------------------------------
        v-dialog(v-model="calculating", hide-overlay, persistent, width="320")
          v-card(color="primary white--text")
            v-card-title.pa-0
              v-spacer
              v-btn(flat small color="white" @click="calculating = false")
                | {{$t('cancel')}}
                v-icon(small) close
            v-card-text
              app-progress(:val="calculateProgress.estimate", :title="'計算しています'")
              app-progress(:val="calculateProgress.generate", :title="'画像を生成しています'")
              app-progress(:val="calculateProgress.preview", :title="'プレビューを生成しています'")
              v-progress-linear(indeterminate color="white")
</template>

<script>
import Three, {
  Box,
  Frame,
  Size,
  Thick,
  Face,
  ClogFactory
} from '../Components/Three'
import rules from '@/common/mixins/rules'
import AppProgress from './progress.vue'

const WAIT = 0
const LOAD = 1
const DONE = 2

const initInput = () => {
  return {
    method: 1,
    heavy: false,
    width: 1000,
    height: 1000,
    depth: 1000,
    stamps: [],
    clog: false,
    stack: false,
    quantity: 1,
    limitValidation: true,
    widthGteDepth: true
  }
}

export default {
  components: {
    AppProgress
  },
  data () {
    return {
      step: 1,
      calculating: false,
      calculateProgress: {
        estimate: WAIT,
        generate: WAIT,
        preview: WAIT
      },
      selection: null,
      inputs: [initInput()],
      token: null,
      preview: null,
      customer: {
        company: '',
        name: '',
        email: '',
        tel: ''
      },
      boxesForThree: [],
      previewDialog: false
    }
  },
  mixins: [rules],
  watch: {
    previewDialog: v => {
      if (!v) {
        Three.deactivate()
      }
    }
  },
  created () {
    this.$ajax.get('/request/selection').then(response => {
      this.selection = response.data
    })
  },
  beforeDestroy () {},
  computed: {
    isMobile () {
      return window.innerWidth < 600
    },
    cleansing () {
      return this.inputs.map(input => {
        return {
          method: parseInt(input.method, 10),
          heavy: input.heavy,
          width: parseInt(input.width, 10),
          height: parseInt(input.height, 10),
          depth: parseInt(input.depth, 10),
          stamps: input.stamps.map(stamp => {
            return {
              id: parseInt(stamp.id, 10)
            }
          }),
          clog: input.clog,
          stack: input.stack,
          quantity: parseInt(input.quantity, 10)
        }
      })
    }
  },
  methods: {
    correlatedInput (index, key, value) {
      this.inputs[index][key] = value
      const i = this.inputs[index]
      const width = parseInt(i.width, 10)
      const height = parseInt(i.height, 10)
      const depth = parseInt(i.depth, 10)
      this.inputs[index].limitValidation = !(
        (width > 1400 && height > 1400) ||
        (width > 1400 && depth > 1400) ||
        (height > 1400 && depth > 1400)
      )
      this.inputs[index].widthGteDepth = width >= depth
    },
    addInput () {
      if (this.inputs.length >= 3) {
        return
      }
      this.inputs.push(initInput())
    },
    removeInput (index) {
      if (this.inputs.length <= index) {
        return
      }
      if (this.inputs.length === 1 && index === 0) {
        this.inputs.splice(index, 1, initInput())
        return
      }
      this.inputs.splice(index, 1)
    },
    methodString (methodId) {
      if (!this.selection) {
        return ''
      }
      return this.selection.methods.find(method => method.id === methodId).name
    },
    stampsString (stamps) {
      return stamps.map(stamp => stamp.name).join(', ')
    },
    async doEstimate () {
      if (this.hasRuleError()) {
        this.$toastr.warning(this.$t('_rules.invalidate_message'))
        return true
      }
      this.calculateProgress.estimate = WAIT
      this.calculateProgress.generate = WAIT
      this.calculateProgress.preview = WAIT
      this.calculating = true
      this.calculateProgress.estimate = LOAD
      this.token = (await this.$ajax.post(
        '/request/calculate',
        this.cleansing,
        { loading: false }
      )).data
      this.calculateProgress.estimate = DONE
      this.calculateProgress.generate = LOAD
      const boxesForThree = (await this.$ajax.get(
        `/request/boxes_for_three/${this.token}`,
        { loading: false }
      )).data
      for (let boxForThree of boxesForThree) {
        const image = await Three.createImage(
          new Frame(320, 320, true),
          new Box(
            new Size(boxForThree.w, boxForThree.h, boxForThree.d),
            new Thick(boxForThree.t.t, boxForThree.t.s, boxForThree.t.b),
            new Face(boxForThree.f.t, boxForThree.f.s, boxForThree.f.b),
            new Size(boxForThree.c.w, boxForThree.c.h, boxForThree.c.d),
            new Size(boxForThree.s.x, boxForThree.s.y, boxForThree.s.z),
            ClogFactory.create(
              boxForThree.g.calc,
              boxForThree.g.w,
              boxForThree.g.h,
              boxForThree.g.deck,
              boxForThree.g.num,
              boxForThree.g.cls,
              boxForThree.g.wbs,
              boxForThree.g.dbs,
              boxForThree.g.direction
            )
          )
        )
        boxForThree.image = image
      }
      await this.$ajax.post(
        `/request/save_images/${this.token}`,
        boxesForThree,
        { loading: false }
      )
      this.calculateProgress.generate = DONE
      this.calculateProgress.preview = LOAD
      const uri = (await this.$ajax.get(
        `/request/preview_quotation/${this.token}`,
        { loading: false }
      )).data.uri
      this.preview = uri
      // console.log(boxesForThree)
      this.boxesForThree = boxesForThree
      this.calculateProgress.preview = DONE
      this.calculating = false
      this.step = 3
    },
    previewDownload () {
      const v = window.open()
      v.location.href = this.preview
    },
    openPreview (index) {
      const boxForThree = this.boxesForThree[index]
      console.log(boxForThree)
      let div = document.getElementById('preview-canvas')
      Three.activate(
        new Frame(
          this.isMobile ? 340 : 580,
          this.isMobile ? 340 : 580,
          false,
          div
        ),
        new Box(
          new Size(boxForThree.w, boxForThree.h, boxForThree.d),
          new Thick(boxForThree.t.t, boxForThree.t.s, boxForThree.t.b),
          new Face(boxForThree.f.t, boxForThree.f.s, boxForThree.f.b),
          new Size(boxForThree.c.w, boxForThree.c.h, boxForThree.c.d),
          new Size(boxForThree.s.x, boxForThree.s.y, boxForThree.s.z),
          ClogFactory.create(
            boxForThree.g.calc,
            boxForThree.g.w,
            boxForThree.g.h,
            boxForThree.g.deck,
            boxForThree.g.num,
            boxForThree.g.cls,
            boxForThree.g.wbs,
            boxForThree.g.dbs,
            boxForThree.g.direction
          )
        )
      ).then(() => {
        this.previewDialog = true
      })
    },
    closePreview () {
      this.previewDialog = false
    },
    toConfirm () {
      if (this.hasRuleError()) {
        this.$toastr.warning(this.$t('_rules.invalidate_message'))
        return true
      }
      this.step = 5
    },
    doRequest () {
      if (this.hasRuleError()) {
        this.$toastr.warning(this.$t('_rules.invalidate_message'))
        return true
      }
      this.$ajax
        .post(`/request/save/${this.token}`, this.customer)
        .then(response => {
          this.inputs = [initInput()]
          this.token = null
          this.preview = null
          this.step = 6
        })
    }
  }
}
</script>

<style scoped lang="stylus">
.preview-canvas {
  padding: 20px;
  z-index: 9999;
}

.preview-card {
  position: relative;

  .preview-3d {
    position: absolute;
    top: 20px;
    right: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/app/pages/Order/Request/index.vue